(function () {
  const el = document.getElementById("preloader-mosaic");
  if (!el) return;

  const hideMode = el.dataset.hideMode || "onload";
  const duration = parseFloat(el.dataset.duration || "2.6") * 1000;
  const showMode = el.dataset.showMode || "session";
  const fadeStyle = el.dataset.fadeStyle || "fade-blur";

  const keySession = "aleix_preloader_seen_session";
  const keyDaily = "aleix_preloader_seen_day";
  const today = new Date().toISOString().slice(0, 10);

  function shouldShow() {
    if (showMode === "always") return true;
    if (showMode === "session") return !sessionStorage.getItem(keySession);
    if (showMode === "daily") return localStorage.getItem(keyDaily) !== today;
    return true;
  }

  function markSeen() {
    if (showMode === "session") sessionStorage.setItem(keySession, "1");
    if (showMode === "daily") localStorage.setItem(keyDaily, today);
  }

  function activate() {
    el.classList.add("is-active");
    // force paint
    requestAnimationFrame(() => {
      el.classList.add("is-visible");
      el.classList.add("breeze");
      staggerTiles();
    });
  }

  function staggerTiles() {
    const tiles = el.querySelectorAll(".preloader-mosaic__tile");
    tiles.forEach((tile, i) => {
      tile.style.transitionDelay = `${(i * 55) + 120}ms`;
    });
  }

  function exit() {
    if (el.classList.contains("is-exiting")) return;
    el.classList.add("is-exiting");
    el.classList.add(fadeStyle);

    setTimeout(() => {
      el.classList.remove("is-active", "is-visible", "breeze", "is-exiting", fadeStyle);
      el.style.display = "none";
    }, 900);
  }

  // Skip button
  const skipBtn = el.querySelector(".preloader-mosaic__skip");
  if (skipBtn) {
    skipBtn.addEventListener("click", () => {
      markSeen();
      exit();
    });
  }

  // Show logic
  if (!shouldShow()) {
    el.style.display = "none";
    return;
  }

  activate();
  markSeen();

  if (hideMode === "timer") {
    setTimeout(exit, duration);
  } else {
    window.addEventListener("load", () => {
      // small delay to feel premium
      setTimeout(exit, 420);
    });
  }
})();
